import SurveyPopover from '@/components/Surveys/SurveyPopover'
import { hDeepCopy } from '@/utils/helpers';
// @vue/component
export default {
  name: 'SurveyCreator',

  components: {
    SurveyPopover
  },
  props: {
    projectsList: {
      type: Array,
      default: () => [],
    }
  },

  data() {
    return {
      actionType: 'add',
      idCounterForNewRecords: 0,
      name: '',
      selectedSurveyUuid: '',
      questions: [],
      isNewQuestionCreateVisible: false,
      questionForm: {
        newQuestionInputType: '',
        newQuestionText: '',
        newQuestionDescription: '',
        answersForCheckboxQuestion: [],
      },
      mouseOverQuestionIndex: null,
      draggedItem: null,
      isItemDragged: false,
      rules: {
        newQuestionInputType: [
          { required: true, message: 'Treść jest wymagana.', trigger: 'blur' },
        ],
        newQuestionText: [
          { required: true, message: 'Typ pola jest wymagany.', trigger: 'blur' },
        ],
        answersForCheckboxQuestion: [
          { required: true, message: 'Wymagana jest przynajmniej jedna odpowiedź.', trigger: 'change' },
        ],
      },
      selectedProjectUuid: '',
      newCheckboxAnswer: '',
      isFetchingSurveys: false,
    };
  },

  watch: {
    actionType: {
      handler() {
        this.selectedSurveyUuid = '';
        this.selectedProjectUuid = '';
        this.newCheckboxAnswer = '';
        this.name = '';
        this.questions = [];
        this.isNewQuestionCreateVisible = false;
      },
      immediate: true
    }
  },
  async created() {
    await this.$store.dispatch('campaign/getSurveyInputTypesList');

  },

  computed: {
    surveyInputTypesList() {
      return this.$store.getters['campaign/surveyInputTypesList'];
    },
    surveyQuestions() {
      return this.$store.getters['campaign/surveyQuestions'];
    },
    selectedType() {
      return this.surveyInputTypesList.filter(item => item.html_type === this.questionForm.newQuestionInputType)[0];
    },
    isSubmitDisabled() {
      return this.questions.length === 0 || (!this.name && !this.selectedSurveyUuid) || !this.selectedProjectUuid;
    },
    surveysList() {
      return this.$store.getters['campaign/surveysList'];
    }
  },

  methods: {
    createNewQuestion() {
      this.$refs.questionForm.validate((valid) => {
        if (valid) {
          this.questions.push({
            _question: this.questionForm.newQuestionText,
            _description: this.questionForm.newQuestionDescription,
            _html_type: this.selectedType.html_type,
            _type_name: this.selectedType.type_name,
            _type_description: this.selectedType.description,
            _question_id: this.idCounterForNewRecords,
            _checkbox_answers: this.questionForm.answersForCheckboxQuestion.length > 0 ? this.questionForm.answersForCheckboxQuestion : null,
          });
          this.idCounterForNewRecords += 1;
          this.isNewQuestionCreateVisible = false;
          this.$refs.questionForm.resetFields();
          this.questionForm.answersForCheckboxQuestion = [];
          this.newCheckboxAnswer = '';
        }
      });
    },
    startDrag(event, index) {
      event.dataTransfer.dropEffect = 'move';
      event.dataTransfer.effectAllowed = 'move';
      this.draggedItem = this.questions[index];
      this.isItemDragged = true;
    },
    onDrop() {
      this.isItemDragged = false;
    },
    dragOver(event, mouseOverIndex) {
      if (!event.target.classList.contains("list-move")) {
        this.mouseOverQuestionIndex = mouseOverIndex;
        this.questions.splice(this.questions.indexOf(this.draggedItem), 1);
        this.questions.splice(this.mouseOverQuestionIndex, 0, this.draggedItem);
      }
    },
    handleQuestionTypeChange() {
      this.questionForm.answersForCheckboxQuestion = [];
    },
    handleRemoveQuestion(questionId) {
      this.questions = this.questions.filter(question => question._question_id !== questionId)
    },
    async submitSurveyChanges() {
      const prepareQuestionsArray = [];
      this.questions.forEach(element => {
        prepareQuestionsArray.push({
          question: element._question,
          description: element._description,
          type_name: element._type_name,
          checkbox_answers: element._checkbox_answers ? element._checkbox_answers : null,
        })
      });
      if (this.actionType === 'add') {
        const params = {
          survey_name: this.name,
          questions: prepareQuestionsArray,
          project_uuid: this.selectedProjectUuid
        };
        const responseStatus = await this.$store.dispatch('campaign/createNewSurvey', params);
        await this.$store.dispatch('campaign/getSurveysList', this.selectedProjectUuid);
        if (responseStatus === 200) {
          this.$message({
            type: 'success',
            message: "Utworzono nową ankietę.",
          });
          this.questions = [];
          this.name = '';
          this.idCounterForNewRecords = 0;
          this.newCheckboxAnswer = '';
        } else {
          this.$message({
            type: 'error',
            message: "Wystąpił błąd podczas tworzenia nowej ankiety",
          });
        }
      } else {
        const params = {
          survey_uuid: this.selectedSurveyUuid,
          questions: prepareQuestionsArray,
          project_uuid: this.selectedProjectUuid
        };

        const responseStatus = await this.$store.dispatch('campaign/editSurvey', params);
        await this.$store.dispatch('campaign/getSurveysList', this.selectedProjectUuid);
        if (responseStatus === 200) {
          this.$message({
            type: 'success',
            message: "Zmiany zostały zapisane.",
          });
          this.questions = [];
          this.selectedSurveyUuid = '';
          this.idCounterForNewRecords = 0;
          this.newCheckboxAnswer = '';
        } else {
          this.$message({
            type: 'error',
            message: "Wystąpił błąd podczas edycji ankiety",
          });
        }
      }
    },
    addNewAnswer() {
      if (this.newCheckboxAnswer) {
        if (this.questionForm.answersForCheckboxQuestion.indexOf(this.newCheckboxAnswer) !== -1) return;
        this.questionForm.answersForCheckboxQuestion.push(this.newCheckboxAnswer)
        this.newCheckboxAnswer = '';
      }
    },
    handleRemoveAnswer(answerIndex) {
      this.questionForm.answersForCheckboxQuestion.splice(answerIndex, 1)
    },
    async getSurveysList() {
      this.selectedSurveyUuid = '',
      this.isFetchingSurveys = true;
      await this.$store.dispatch('campaign/getSurveysList', this.selectedProjectUuid);
      this.isFetchingSurveys = false;
    },
    async selectSurvey() {
      await this.$store.dispatch('campaign/getSurveyQuestions', this.selectedSurveyUuid);
      this.questions = hDeepCopy(this.surveyQuestions)
      const lastItem = this.questions[this.questions.length - 1]
      this.idCounterForNewRecords = lastItem._question_id + 1

    },
  }
};
